import { InsuranceMediaContent } from '../../../Insurance/utils/types';
import { MyProfileSubmit } from '../../../MyProfile/Patient/utils/types';

export const stateFundedProgramOptions = [
  { id: 1, value: 'yes', label: 'Yes' },
  { id: 2, value: 'no', label: 'No' },
  { id: 3, value: 'not_sure', label: `I'm not sure` },
];

export type SelectNeedsSubmit = {
  dental_emergency: string;
  something_else: string;
};

export interface SelectedAppointment {
  selectedDate?: string | null;
  selectedTimeSlot: string;
  selectedDateTime?: string | null;
  selectedProviderId?: number | undefined;
  selectedCareAdvisorId?: number | undefined;
}

export type DescribePainLevelSubmit = {
  inPain: string;
  describePain: string[];
  painLevel: string;
  daysInPain: string;
  anythingElse: string;
};

export type AdditionalInformationSubmit = {
  anythingElse: string;
};

export type PatientInsuranceForm = {
  group_number?: string;
  member_id: string;
  iPhoneNumber: string;
  insurance_through: string;
  secondary_group_number?: string;
  secondary_member_id: string;
  secondary_iPhoneNumber: string;
  secondary_insurance_through: string;
  secondary_insurance_address: string;
  secondary_insurance_city: string;
  secondary_insurance_state: string;
  secondary_insurance_zip_code: string;
};

export type PatientFormFiveSubmit = {
  insurance_first_name: string;
  insurance_date_of_birth: string;
  insurance_gender: string;
  insurance_last_name: string;
  insurance_address1: string;
  insurance_address2: string;
  insurance_zip_code1: string;
  insurance_state1: string;
  insurance_city1: string;
  insurance_phone_number: string;
  secondary_insurance_phone_number: string;
  other_insurance_name: string;
  secondary_insurance_first_name: string;
  secondary_insurance_date_of_birth: string;
  secondary_insurance_gender: string;
  secondary_insurance_last_name: string;
  secondary_insurance_address1: string;
  secondary_insurance_address2: string;
  secondary_insurance_zip_code1: string;
  secondary_insurance_state1: string;
  secondary_insurance_city1: string;
  creditCardFullName: string;
  creditCardNumber: string;
  creditCardAddress1: string;
  creditCardAddress2: string;
  expiryDate: string;
  creditCardZipCode: string;
  cvvNumber: string;
  creditCardState: string;
  creditCardCity: string;
  insurance_address?: string;
  insurance_city?: string;
  insurance_state?: string;
  insurance_zip_code?: string;
  front_of_card: InsuranceMediaContent[];
  back_of_card: InsuranceMediaContent[];
  secondary_front_of_card: InsuranceMediaContent[];
  secondary_back_of_card: InsuranceMediaContent[];
} & MyProfileSubmit &
  PatientInsuranceForm;

export type PatientNotCoveredInsuranceSubmit = {
  creditCardFullName?: string;
  creditCardNumber?: string;
  creditCardAddress1?: string;
  creditCardAddress2?: string;
  expiryDate?: string;
  creditCardZipCode?: string;
  cvvNumber?: string;
  creditCardState?: string;
  creditCardCity?: string;
};
